// extracted by mini-css-extract-plugin
module.exports = {"testName":"TestName_testName__bd4CG"};